import React from 'react';
import BentoCard from '../ui/BentoCard';
import { useLoyalty } from '../../contexts/LoyaltyContext';

function LoyaltyStatsBento() {
  const { programs, totalValue, monthlyEarned } = useLoyalty();

  const topProgram = programs.reduce((best, p) => {
    if (!best) return p;
    if (p.tier !== 'Member' && best.tier === 'Member') return p;
    return best;
  }, programs[0] || null);

  const formattedValue = totalValue.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });

  return (
    <div className="grid grid-cols-2 gap-3">
      <BentoCard className="bg-gradient-to-br from-primary/[0.03] to-primary/[0.07]">
        <div className="flex items-center gap-1.5 mb-2">
          <span className="material-symbols-outlined text-primary" style={{ fontSize: 20 }}>
            monetization_on
          </span>
        </div>
        <p className="text-xs text-on-surface-variant">Estimated Value</p>
        {programs.length > 0 ? (
          <>
            <p className="text-2xl font-bold text-on-surface mt-1">{formattedValue}</p>
            <p className="text-xs text-on-surface-variant mt-0.5">
              across {programs.length} program{programs.length !== 1 ? 's' : ''}
            </p>
          </>
        ) : (
          <>
            <p className="text-2xl font-bold text-on-surface mt-1">$0</p>
            <p className="text-xs text-on-surface-variant mt-0.5">no programs yet</p>
          </>
        )}
      </BentoCard>

      {topProgram && topProgram.tier !== 'Member' ? (
        <BentoCard className="bg-gradient-to-br from-warning/[0.03] to-warning/[0.07]">
          <div className="flex items-center gap-1.5 mb-2">
            <span className="material-symbols-outlined text-warning" style={{ fontSize: 20 }}>
              workspace_premium
            </span>
          </div>
          <p className="text-xs text-on-surface-variant">Top Status</p>
          <p className="text-lg font-bold text-on-surface mt-1 leading-tight">{topProgram.tier}</p>
          <p className="text-xs text-on-surface-variant mt-1 truncate">
            {topProgram.programId
              .split('-')
              .slice(0, 2)
              .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
              .join(' ')}
          </p>
        </BentoCard>
      ) : (
        <BentoCard className="bg-gradient-to-br from-success/[0.03] to-success/[0.07]">
          <div className="flex items-center gap-1.5 mb-2">
            <span className="material-symbols-outlined text-success" style={{ fontSize: 20 }}>
              trending_up
            </span>
          </div>
          <p className="text-xs text-on-surface-variant">Earned This Month</p>
          <p className="text-2xl font-bold text-on-surface mt-1">
            {monthlyEarned > 0 ? monthlyEarned.toLocaleString() : '—'}
          </p>
          <p className="text-xs text-on-surface-variant mt-0.5">points / miles</p>
        </BentoCard>
      )}
    </div>
  );
}

export default LoyaltyStatsBento;
